// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import "./channels"
import "./navigation"

// Vendored Flatpickr 4.6.13 — pinned, audited (see specs/2026-05-01-custom-timeframe-design.md §8).
// Attaches `window.flatpickr`, used by timeframe_filter_controller.js.
import "../../vendor/javascript/flatpickr/flatpickr-4.6.13.min.js"
